/**
 * Redeem-codes API client —— 运营后台兑换码生码 / 列表。
 *
 * 包装 axios apiClient 调用 admin-service /redeem-codes 端点。
 * 列表需 redeem_code:read（明文未用码，单独点位）；生码本质是发免单券的入口，复用 voucher:grant。
 */
import { apiClient } from './client';

export interface RedeemCodeDto {
  code: string;
  voucherType: string;
  status: 'unused' | 'used';
  batch: string | null;
  note: string | null;
  usedByUserId: string | null;
  usedAt: number | null;
  voucherId: string | null;
  expireAt: number | null;
  createdAt: number;
  updatedAt: number;
}

export interface ListRedeemCodesFilter {
  status?: 'unused' | 'used';
  batch?: string;
  limit?: number;
}

export interface ListRedeemCodesResponse {
  items: RedeemCodeDto[];
  total: number;
}

export interface GenerateRedeemCodesInput {
  count: number;
  batch?: string;
  note?: string;
  /** epoch-ms；不传 = 永久 */
  expireAt?: number;
}

export interface GenerateRedeemCodesResponse {
  codes: string[];
}

interface ServiceResponse<T> {
  code: number;
  message: string;
  data: T;
  requestId: string;
}

export async function listRedeemCodes(
  filter: ListRedeemCodesFilter = {},
): Promise<ListRedeemCodesResponse> {
  const params: Record<string, string> = {};
  if (filter.status) params.status = filter.status;
  if (filter.batch) params.batch = filter.batch;
  if (filter.limit != null) params.limit = String(filter.limit);
  const resp = await apiClient.get<ServiceResponse<ListRedeemCodesResponse>>(
    '/redeem-codes',
    { params },
  );
  return resp.data.data;
}

export async function generateRedeemCodes(
  input: GenerateRedeemCodesInput,
): Promise<GenerateRedeemCodesResponse> {
  const resp = await apiClient.post<ServiceResponse<GenerateRedeemCodesResponse>>(
    '/redeem-codes/generate',
    input,
  );
  return resp.data.data;
}

export interface RedeemFunnelRow {
  batch: string | null;
  totalCodes: number;
  assigned: number;
  redeemed: number;
  remaining: number;
  narratedUsers: number;
  narratedMinutes: number;
  chapterUsers: number;
  paidUsers: number;
}

export interface RedeemFunnelResponse {
  chapterThreshold: number;
  rows: RedeemFunnelRow[];
}

export async function getRedeemFunnel(): Promise<RedeemFunnelResponse> {
  const resp = await apiClient.get<ServiceResponse<RedeemFunnelResponse>>(
    '/redeem-codes/funnel',
  );
  return resp.data.data;
}
